// extracted by mini-css-extract-plugin
export default {"serverMessageWrapper":"ServerMessageManager_serverMessageWrapper__s6UVM","message":"ServerMessageManager_message__sYjLi"};